<div class="table-sio vertical-top w-100">
    <div class="row-sio mt-10x">
        <div class="cell-sio">
            <div class="position-relative">
                <ng-container *ngIf="selectedVar !=''">
                    <buscador-cotizador #buscadorCotizador [apiName]="apiName" [remoteName]="remoteName" [data]="[{'m':modeloAuto},{'c':aseguradoraId}, {'p': pickup}, {'negocio_id': negocioId},{'tipoVehiculoBuscador': tipoVehiculoBuscador}]"
                        [abrevia]="abrevia" (redirect)="redirect($event)" [minLetras]="1" (focus)="onFocus()" (keyup)="onKeyup($event)"
                        (eventKeyUP)="eventKeyBoard($event)">
                    </buscador-cotizador>
                    <!-- <ng-container *ngIf="habilitarBoton">
                        <div class="contenedorIcono">
                            <mat-icon id="DTAB-ico-abrirModalInfoVehiculo" class="iconoEnBusqueda" (click)="abrirModalInfoVehiculo()">
                                help
                            </mat-icon>
                        </div>
                    </ng-container> -->
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="tabla-sio container-control-vehiculo">
    <ng-container *ngIf="auto && selectauto?.c1 && amis != ''; else noEstaMiAuto">
        <div class='table-sio w-100 h-70x' *ngIf="selectauto.c1 && amis != ''">
            <div class='row-sio w-100'>
                <div class='cell-sio text-middle'>
                    <img [src]='selectauto.c6' class="tamano-logo" [alt]='selectauto.c4'>
                </div>
                <div class='cell-sio pl-20x align-middle'>
                    <div class='table-sio'>
                        <div class='row-sio'>
                            <div class='cell-sio'>
                                <div class='text-elipsis-two-line' [title]='selectauto.c3'>
                                    <b class="font-600">{{selectauto.c3}}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #noEstaMiAuto>
        <div class="table-sio w-100">
            <div class="row-sio">
                <div class="cell-sio text-center">
                    <a class="link linkC" (click)="goNoEstaMiAuto()" >No encuentro mi auto</a>  
                </div>
            </div>
            <div class="row-sio">
                <div class="cell-sio text-center">
                    <p class="text-purple"></p>  
                </div>
            </div>
        </div>
    </ng-template>
</div>